enum AuthenticationMode {
	LogIn,
	SignUp
}

export default AuthenticationMode
